import * as e from "react";
import t, { useState as n, useRef as r, useEffect as o } from "react";

var i = function i(e, t, n, r) {
  return void 0 === n && (n = ""), void 0 === r && (r = "wmk"), [r + "-" + t, r + "-" + t + "-" + e, n].join(" ").trim();
},
    l = function l(t) {
  var n = t.className,
      r = t.id;
  return e.createElement("div", {
    className: i("flex-spacer", "layout", n),
    id: r,
    style: {
      margin: "auto"
    }
  });
},
    u = function u(t) {
  var n = t.children,
      r = t.Header,
      o = void 0 === r ? e.createElement("div", null, "Pass Header JSX") : r,
      u = t.Footer,
      s = void 0 === u ? e.createElement("div", null, "Pass Footer JSX") : u,
      a = t.className;
  return e.createElement("div", {
    className: i("wrap", "layout"),
    style: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column"
    }
  }, o, e.createElement("main", {
    className: i("main", "layout", a)
  }, n), e.createElement(l, null), s);
},
    s = e.forwardRef(function (t, n) {
  var r = t.children,
      o = t.className,
      l = t.id,
      u = new Date().getFullYear();
  return e.createElement("div", {
    id: l,
    className: i("copyright", "layout", o),
    ref: n
  }, "© ", u, " ", r || null);
}),
    _a = function a() {
  return _a = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var o in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  }, _a.apply(this, arguments);
},
    c = {},
    d = {},
    f = {};

Object.defineProperty(f, "__esModule", {
  value: !0
}), f.useIsomorphicLayoutEffect = void 0;
var m = t;
f.useIsomorphicLayoutEffect = "undefined" != typeof window ? m.useLayoutEffect : m.useEffect, function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.useScrollPosition = void 0;

  var n = t,
      r = f,
      o = "undefined" != typeof window,
      i = {
    x: 0,
    y: 0
  },
      l = function l(e) {
    return null == e ? void 0 : e.getBoundingClientRect();
  },
      u = function u(_ref) {
    var e = _ref.element,
        t = _ref.useWindow,
        n = _ref.boundingElement;
    if (!o) return i;
    if (t) return {
      x: window.scrollX,
      y: window.scrollY
    };
    var r = l((null == e ? void 0 : e.current) || document.body),
        u = l(null == n ? void 0 : n.current);
    return r ? u ? {
      x: (u.x || 0) - (r.x || 0),
      y: (u.y || 0) - (r.y || 0)
    } : {
      x: r.left,
      y: r.top
    } : i;
  };

  e.useScrollPosition = function (e, t, i, l, s, a) {
    var c = n.useRef(u({
      useWindow: l,
      boundingElement: a
    }));
    var d = null;

    var f = function f() {
      var t = u({
        element: i,
        useWindow: l,
        boundingElement: a
      });
      e({
        prevPos: c.current,
        currPos: t
      }), c.current = t, d = null;
    };

    r.useIsomorphicLayoutEffect(function () {
      var e;
      if (!o) return;

      var t = function t() {
        s ? null === d && (d = setTimeout(f, s)) : f();
      };

      return a ? null === (e = a.current) || void 0 === e || e.addEventListener("scroll", t, {
        passive: !0
      }) : window.addEventListener("scroll", t, {
        passive: !0
      }), function () {
        var e;
        a ? null === (e = a.current) || void 0 === e || e.removeEventListener("scroll", t) : window.removeEventListener("scroll", t), d && clearTimeout(d);
      };
    }, t);
  }, e.useScrollPosition.defaultProps = {
    deps: [],
    element: !1,
    useWindow: !1,
    wait: null,
    boundingElement: !1
  };
}(d), function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var t = d;
  Object.defineProperty(e, "useScrollPosition", {
    enumerable: !0,
    get: function get() {
      return t.useScrollPosition;
    }
  });
}(c);

var v = e.forwardRef(function (t, n) {
  var r = t.children,
      o = t.className,
      l = t.style;
  return e.createElement("header", {
    className: i("header", "layout", o),
    style: l,
    ref: n
  }, r);
}),
    y = function y(t) {
  var l = t.Alert,
      u = void 0 === l ? e.createElement(e.Fragment, null) : l,
      s = t.className,
      d = t.children,
      f = t.absolute,
      m = t.style,
      y = t.zIndex,
      h = void 0 === y ? 1e3 : y,
      w = t.width,
      p = void 0 === w ? "100%" : w,
      E = t.trigger,
      g = void 0 === E ? 0 : E,
      P = f ? "absolute" : "relative",
      b = n({
    y: 0,
    height: 0,
    width: 0,
    x: 0,
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    toJSON: function toJSON() {
      return "";
    }
  }),
      x = b[0],
      N = b[1],
      L = n(0),
      S = L[0],
      j = L[1],
      O = n(),
      _ = O[0],
      F = O[1],
      I = r();
  o(function () {
    F(window.location.href);

    var e = function e() {
      N(I.current.getBoundingClientRect());
    };

    return e(), window.addEventListener("resize", e), function () {
      return window.removeEventListener("resize", e);
    };
  }, [_]), c.useScrollPosition(function (e) {
    var t = e.currPos;
    j(-1 * t.y);
  });
  var R = [s],
      z = S > (u || x.y ? x.y : g >= 0 ? g : x.height);
  return z && R.push("stuck"), e.createElement(e.Fragment, null, e.createElement("div", {
    className: i("sticky-header", "layout", R.join(" ")),
    style: _a(_a({}, m), {
      position: z ? "fixed" : P,
      zIndex: h,
      width: p
    })
  }, z ? null : u, e.createElement(v, {
    ref: I
  }, d)), u && z ? e.createElement("div", {
    style: {
      height: x.y
    }
  }) : null, z && e.createElement("div", {
    style: {
      height: x.height
    }
  }));
};

export { s as Copyright, u as MainLayout, y as Sticky };